import { render, staticRenderFns } from "./openexperiment.vue?vue&type=template&id=6f3fd6e0&scoped=true&"
import script from "./openexperiment.vue?vue&type=script&lang=js&"
export * from "./openexperiment.vue?vue&type=script&lang=js&"
import style0 from "./openexperiment.vue?vue&type=style&index=0&id=6f3fd6e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3fd6e0",
  null
  
)

export default component.exports